// Temporary review aid, available locally and on the designated sandbox shop.
export default function ErrorPreviewControls({ search, shopDomain, cases, onClear }: {
    search: string;
    shopDomain?: string;
    cases: { label: string; onShow: () => void }[];
    onClear: () => void;
}) {
    const isSandbox = shopDomain?.toLowerCase() === 'sportsbike-partfits-sandbox.myshopify.com';
    if ((process.env.NODE_ENV === 'production' && !isSandbox) ||
        new URLSearchParams(search).get('previewErrors') !== '1') return null;
    return (
        <s-stack gap="small-200" paddingBlock="small">
            <s-text color="subdued">Error preview · These buttons only show sample messages.</s-text>
            <s-stack direction="inline" gap="small-200">
                {cases.map(item => <s-button key={item.label} onClick={item.onShow}>{item.label}</s-button>)}
                <s-button onClick={onClear}>Clear error preview</s-button>
            </s-stack>
        </s-stack>
    );
}
